import { Resources } from 'constants/resources';

import { useDeleteGatewayConversionSettings } from 'pages/Monitoring/OrderConversion/OrderConversionList/hooks/useDeleteGatewayConversionSettings';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { TypographyWithBold } from 'shared/mui/Typography';
import { GatewayConversionListItem } from 'types/embedded/orderConversion';

type Props = {
  onClose: VoidFunction;
  onCancel: (record: GatewayConversionListItem | undefined) => void;
  open: boolean;
  record: GatewayConversionListItem | undefined;
};

export const OrderConversionListGatewayDelete: React.FC<Props> = ({
  onClose,
  onCancel,
  open,
  record,
}) => {
  const translate = useTypedTranslate();
  const notify = useNotify();
  const { deleteGatewayConversionSettings } = useDeleteGatewayConversionSettings();

  async function onDelete() {
    if (!record?.gatewayConversionSettingId) {
      return;
    }

    await deleteGatewayConversionSettings.mutateAsync({
      id: record?.gatewayConversionSettingId,
    });

    notify(
      <TypographyWithBold
        text={translate('app.orderConversion.settingsDeletedSuccessfully', {
          gateway: record.name,
        })}
      />,
      { type: 'success' },
    );

    onClose();
    await queryClient.refetchQueries({ queryKey: [Resources.OrderConversion] });
  }

  return (
    <DeleteDialog
      details={`Настройки уведомлений для ${record?.id} ${record?.name} будет удалены без возможности восстановления.`}
      isLoading={deleteGatewayConversionSettings?.isPending}
      onCancel={() => {
        onCancel(record);
      }}
      onClose={onClose}
      onDelete={onDelete}
      onSuccess={onClose}
      open={open}
      title="Удаление настроек уведомления для шлюза"
    />
  );
};
